__turbopack_context__.v({
  "container": "vvyUtG_container",
  "disabled": "vvyUtG_disabled",
  "emptyPlaceholder": "vvyUtG_emptyPlaceholder",
  "footerSection": "vvyUtG_footerSection",
  "header": "vvyUtG_header",
  "loadMoreButton": "vvyUtG_loadMoreButton",
  "orderList": "vvyUtG_orderList",
  "pastOrdersButton": "vvyUtG_pastOrdersButton",
  "row": "vvyUtG_row",
});
